import { AiOutlineEdit } from "react-icons/ai";
import CommissionsRow from "./CommissionsRow";

type Props = { data: any };

const TeamMemberCommissions = ({ data }: Props) => {
  console.log(data);

  return (
    <div className="bg-white p-4 rounded-lg">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-color-primary text-xl font-semibold">
          Member Commissions
        </h3>
        <AiOutlineEdit className="text-[#9999A7] flex items-center text-lg justify-center text-center" />
      </div>
      <div className="grid">
        {data?.commission_team_member?.map((e: any, i: any) => (
          <CommissionsRow data={e} i={i} />
        ))}
      </div>
    </div>
  );
};

export default TeamMemberCommissions;
